import { createSlice } from "@reduxjs/toolkit";
import { toGetStatistics } from "../actions/statistics.actions";

const initialState = {
  statistics: {
    list: [],
    status: "",
  } as any,
  loading: false,
  error: null as unknown | null,
};
export const statisticsSlice = createSlice({
  name: "statistics",
  initialState: initialState,
  reducers: {},

  extraReducers: (builder) => {
    builder.addCase(toGetStatistics.pending, (state) => {
      state.statistics = { list: [], status: "idle" };
    });
    builder.addCase(toGetStatistics.fulfilled, (state, action) => {
      state.statistics = { list: action.payload.data, status: "succedded" };
    });
    builder.addCase(toGetStatistics.rejected, (state, action) => {
      state.statistics = { list: [], status: "rejected" };
      state.error = action.payload;
    });
  },
});

export default statisticsSlice.reducer;
